<div class="fixed p-2 right-0 bottom-0 font-standard text-sm z-50">
    v{{version}}
</div>